import { useState } from "react";
import { MapPin } from "lucide-react";
import { useSite, imgUrl } from "@/context/SiteContext";

export default function PortfolioSection({ items }) {
  const { t } = useSite();
  const cats = ["__all", ...new Set(items.map((i) => i.category).filter(Boolean))];
  const [cat, setCat] = useState("__all");
  const shown = cat === "__all" ? items : items.filter((i) => i.category === cat);
  return (
    <section id="portofolio" className="bg-[#0B132B] py-16 text-white blueprint-grid-dark sm:py-24" data-testid="portfolio-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="eyebrow mb-4">{t("pf.eyebrow")}</p>
            <h2 className="max-w-xl text-3xl font-bold tracking-tight lg:text-4xl">{t("pf.title")}</h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`portfolio-filter-${c === "__all" ? "all" : c.toLowerCase().replace(/\W+/g, "-")}`}
                className={`border px-4 py-2 font-mono text-xs uppercase tracking-wider transition-colors ${cat === c ? "border-[#D97706] bg-[#D97706]" : "border-white/20 hover:border-white/60"}`}>{c === "__all" ? t("pf.all") : c}</button>
            ))}
          </div>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {shown.map((p) => (
            <article key={p.id} data-testid={`portfolio-card-${p.id}`} className="group overflow-hidden border border-white/10 bg-[#1C2541]">
              <div className="h-56 overflow-hidden">
                <img src={imgUrl(p.image)} alt={p.title} className="h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-widest text-[#F59E0B]">
                  <span>{p.category} · {p.year}</span><span className="text-emerald-400">{p.result}</span>
                </div>
                <h3 className="mt-3 text-xl font-semibold">{p.title}</h3>
                <p className="mt-1 text-sm text-slate-300">{p.client}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.description}</p>
                <p className="mt-4 flex items-center gap-1.5 text-xs text-slate-400"><MapPin size={12} /> {p.location}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
